"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderers = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var cx = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classNames[_i] = arguments[_i];
    }
    return classNames.filter(function (cn) { return !!cn; }).join(' ');
};
exports.renderers = {
    renderTreeContainer: function (props) { return (react_1.default.createElement("div", { className: cx(core_1.Classes.TREE) },
        react_1.default.createElement("ul", __assign({ className: cx(core_1.Classes.TREE_ROOT, core_1.Classes.TREE_NODE_LIST) }, props.containerProps), props.children))); },
    renderItemsContainer: function (props) { return (react_1.default.createElement("ul", __assign({ className: cx(core_1.Classes.TREE_NODE_LIST) }, props.containerProps), props.children)); },
    renderItem: function (props) { return (react_1.default.createElement("li", __assign({ className: cx(core_1.Classes.TREE_NODE, (props.context.isSelected || props.context.isDraggingOver) &&
            core_1.Classes.TREE_NODE_SELECTED) }, props.context.itemContainerWithChildrenProps),
        react_1.default.createElement("div", __assign({ className: cx(core_1.Classes.TREE_NODE_CONTENT, "".concat(core_1.Classes.TREE_NODE_CONTENT, "-").concat(props.depth)) }, props.context.itemContainerWithoutChildrenProps, props.context.interactiveElementProps),
            props.item.isFolder ? (props.arrow) : (react_1.default.createElement("span", { className: core_1.Classes.TREE_NODE_CARET_NONE })),
            props.item.data.icon !== undefined ? (props.item.data.icon === null ? null : (react_1.default.createElement(core_1.Icon, { icon: props.item.data.icon, className: core_1.Classes.TREE_NODE_ICON }))) : ((function () {
                var icon = !props.item.isFolder
                    ? 'document'
                    : props.context.isExpanded
                        ? 'folder-open'
                        : 'folder-close';
                return react_1.default.createElement(core_1.Icon, { icon: icon, className: core_1.Classes.TREE_NODE_ICON });
            })()),
            props.title),
        react_1.default.createElement("div", { className: cx(core_1.Classes.COLLAPSE), style: props.context.isExpanded
                ? {
                    height: 'auto',
                    overflowY: 'visible',
                    transition: 'none 0s ease 0s',
                }
                : {} },
            react_1.default.createElement(core_1.Collapse, { isOpen: props.context.isExpanded, transitionDuration: 0 }, props.children)))); },
    renderItemArrow: function (props) { return (react_1.default.createElement(core_1.Icon, __assign({ icon: "chevron-right", className: cx(core_1.Classes.TREE_NODE_CARET, props.context.isExpanded
            ? core_1.Classes.TREE_NODE_CARET_OPEN
            : core_1.Classes.TREE_NODE_CARET_CLOSED) }, props.context.arrowProps))); },
    renderItemTitle: function (_a) {
        var title = _a.title, context = _a.context, info = _a.info;
        if (!info.isSearching || !context.isSearchMatching) {
            return react_1.default.createElement("span", { className: core_1.Classes.TREE_NODE_LABEL }, title);
        }
        var startIndex = title.toLowerCase().indexOf(info.search.toLowerCase());
        return (react_1.default.createElement(react_1.default.Fragment, null,
            startIndex > 0 && react_1.default.createElement("span", null, title.slice(0, startIndex)),
            react_1.default.createElement("span", { className: "rct-tree-item-search-highlight" }, title.slice(startIndex, startIndex + info.search.length)),
            startIndex + info.search.length < title.length && (react_1.default.createElement("span", null, title.slice(startIndex + info.search.length, title.length)))));
    },
    renderDragBetweenLine: function (_a) {
        var draggingPosition = _a.draggingPosition, lineProps = _a.lineProps;
        return (react_1.default.createElement("div", __assign({}, lineProps, { style: {
                position: 'absolute',
                right: '0',
                top: draggingPosition.targetType === 'between-items' &&
                    draggingPosition.linePosition === 'top'
                    ? '0px'
                    : draggingPosition.targetType === 'between-items' &&
                        draggingPosition.linePosition === 'bottom'
                        ? '-4px'
                        : '-2px',
                left: "".concat(draggingPosition.depth * 23, "px"),
                height: '4px',
                backgroundColor: core_1.Colors.BLUE3,
            } })));
    },
    renderRenameInput: function (props) { return (react_1.default.createElement("form", __assign({}, props.formProps, { style: { display: 'contents' } }),
        react_1.default.createElement("span", { className: core_1.Classes.TREE_NODE_LABEL },
            react_1.default.createElement("input", __assign({}, props.inputProps, { ref: props.inputRef, className: "rct-tree-item-renaming-input" }))),
        react_1.default.createElement("span", { className: core_1.Classes.TREE_NODE_SECONDARY_LABEL },
            react_1.default.createElement(core_1.Button, __assign({ icon: "tick" }, props.submitButtonProps, { type: "submit", minimal: true, small: true }))))); },
    renderSearchInput: function (props) {
        var _a = __assign({}, props.inputProps), ref = _a.ref, inputProps = __rest(_a, ["ref"]);
        return (react_1.default.createElement("div", { className: cx('rct-tree-search-input-container') },
            react_1.default.createElement(core_1.InputGroup, __assign({ intputRef: ref }, inputProps, { autoFocus: true, placeholder: "Search..." }))));
    },
    renderDepthOffset: 1,
};
